import React, {useEffect, useState} from "react";
import "./coupon.codes.css";


import {dateTimeFormat, loadingAnimation} from "../../services/misc.functions";
import {useNavigate} from "react-router";
import paths from "../../paths";
import {auth} from "../../store/auth.store";

import {modalServiceSubject} from "../../services/modal.service";
import {env} from "../../constants/global.vars";
import {ApiService} from "../../services/http.service";

export function CouponCodes() {
    const [referenceCode, setReferenceCode] = useState<string>("");
    const [dataList, setDataList] = useState<any[]>([]);
    const [page, setPage] = useState<number>(0);
    const navigate = useNavigate();


    const handlerCheckReferenceCode = (paramsCode: any = null) => {
        var code = paramsCode != null ? paramsCode : referenceCode;
        if (code) {
            let api = new ApiService()
            api
                .start("post", env.accounting_api + "/misc/api/coupon-code/subscribe/", {discount_code: code}, true)
                .then((res: any) => {
                    if (res.status) {
                        loadData(0);
                        setReferenceCode("");
                        // toast.success(res.message);
                        modalServiceSubject.next({
                            case: "success",
                            title: "Başarılı",
                            content: res.message,
                            width: 720,
                            confirm: {
                                cancel: {
                                    label: "Tamam",
                                    class: "btn-success",
                                },
                            },
                        });
                    } else {
                        // toast.error(res.message);
                        modalServiceSubject.next({
                            case: "danger",
                            title: "Hata",
                            content: res.message,
                            width: 720,
                            confirm: {
                                cancel: {
                                    label: "Tamam",
                                    class: "btn-danger",
                                },
                            },
                        });
                    }
                })
                .catch((error: any) => {
                    console.error("API isteği başarısız oldu:", error);
                })
                .finally(() => {
                    window.history.pushState(null, "", paths.couponCode.url);
                });
        } else {
            modalServiceSubject.next({
                case: "warning",
                title: "Hata",
                content: "Lütfen Kupon Kodu Giriniz",
                width: 720,
                confirm: {
                    cancel: {
                        label: "Tamam",
                        class: "btn-warning",
                    },
                },
            });
        }
    };

    useEffect(() => {
        setTimeout(() => {
            if (auth.member) {
                loadData();
                const urlParams = new URLSearchParams(window.location.search);
                const code = urlParams.get("code");
                if (code != null) {
                    handlerCheckReferenceCode(code);
                }
            } else {
                navigate(`${paths.login.url}/?n=${paths.couponCode.url}`);
            }
        }, 500);
    }, []);

    const loadData = async (force: any = null) => {
        loadingAnimation(true);
        if (page === 0 || force === 0) {
            setDataList([]);
            setPage(0);
        }

        let payload: any = {
            metadata: {
                page: force != null ? force : page,
            },
            trans_type: "48",
        };
        let api = new ApiService()
        return await api
            .start("post", env.accounting_api + "/member/api/list-transaction/", payload, true)
            .then((res: any) => {
                loadingAnimation(false);
                setPage(page + 1);

                if (res && res.status) {
                    if (force === 0) {
                        setDataList(res.data);
                    } else {
                        dataList.push(...res.data);
                        setDataList(dataList);
                    }
                }

                if (res && res.metadata) {
                    let id_datalist_loadmore: any = document.getElementById("id_datalist_loadmore");

                    if (res.metadata.total_page <= page + 1) {
                        id_datalist_loadmore.style.display = "none";
                    } else {
                        id_datalist_loadmore.style.display = "block";
                    }
                }
            });
    };

    const loadMore = (e: any) => {
        e.target.disabled = true;
        loadData().finally(() => {
            e.target.disabled = false;
        });
    };

    return (
        <div className={""}>
            <div className="gift-ticket-content">
                <div className="gift-ticket-info">
                    <p className="gift-ticket-title">KUPON KODU EKLE</p>
                    <p className={"text-center"}>Sahip olduğunuz kupon kodunu girerek hesabınıza yükleme
                        yapabilirsiniz.</p>
                    {/*<form>*/}
                    <div className="gift-ticket-button justify-content-center">
                        <input
                            value={referenceCode}
                            onChange={(e) => setReferenceCode(e.target.value)}
                            className={"text-center w-50"}
                            placeholder="KUPON KODUNUZU GİRİNİZ"
                        />

                        <button
                            className="btn btn-login ms-2 w-25 py-2"
                            onClick={() => {
                                handlerCheckReferenceCode();
                            }}
                        >
                            YÜKLE
                        </button>
                    </div>
                    {/*</form>*/}
                    {/*<h6 className="gift-ticket-title">{responseMessage}</h6>*/}
                </div>
            </div>

            <div className="card rounded-4 mt-4 page-widget">
                <div className="card-header">
                    <h2 className={"gift-ticket-title"}>KUPON KODLARIM</h2>
                </div>
                <div className="card-body p-4">
                    <div className={`my-raffle-order-item papara-coupon row d-flex justify-content-between m-0`}>
                        {dataList.map((el: any, key: number) => {
                            return (
                                <div key={`item-my-raffle-order-${key}`} className="row item col-sm-12 col-lg-6">
                                    <div className="col-4 d-flex column-center">
                                        {/*{el.trans_type == 38 && <img className={"p-2"} src={paparaLogo} width={60} />}*/}

                                        {el.discount_definition_image ?
                                            <img className="my-1" alt="4NALA"
                                                 src={env.cdn_host + el.discount_definition_image}/> :
                                            <img className="my-1" alt="4NALA"
                                                 src="/assets/logo_tjk_at_yarisi_hipodrom_4nala_atyarisi.svg"/>
                                        }
                                    </div>
                                    <div className="col-8 d-flex justify-content-end flex-column">
                                        <span className="d-block text-end" style={{fontSize: "14px"}}>
                                          Kullanım Tarihi:
                                          <br/>
                                          <span style={{color: "blue"}}> {dateTimeFormat(el.transaction_date)}</span>
                                        </span>

                                        <span className={`text-success fw-bold text-end`}>{el.amount} NP</span>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    {dataList && dataList.length === 0 && (
                        <>
                            <div className="text-center py-5">Listelenecek hiç kayıt yok.</div>
                        </>
                    )}

                    <div className="text-center">
                        <div id="id_loaderAnimation" className="loader"></div>
                        <button
                            id="id_datalist_loadmore"
                            onClick={loadMore}
                            type="button"
                            className="btn rounded-pill btn-outline-primary"
                        >
                            Devamını Yükle
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
